import { useCallback, useEffect, useState } from "react";
import Button from "../../ui/Button";
import { AddIcon } from "../../utils/icon.utils";
import FormSectionTitle from "../../components/styled/FormSectionTitle";
import { arrayMap } from "../../utils/array.utils";
import RemoveVehicleInventoryAccessoriesAckField from "./RemoveVehicleInventoryAccessoriesAckField";
import FormSectionContainer from "../../components/Form/FormSectionContainer";

export default function VehicleInventoryAccessoriesAckField({
  watch,
  control,
  errors,
  unregister,
  setValue,
  others
}) {
  const accessories = others?.defaultValues?.accessories;

  const accessoriesLength = accessories?.length;
  const haveAccessories = !!(accessoriesLength > 0);

  const [fields, setFields] = useState([]);
  const [count, setCount] = useState(haveAccessories ? accessoriesLength : 0);

  // function generate field
  const generateFields = useCallback((item, index) => {
    const currentIndex = index;
    return [
      {
        label: `${currentIndex + 1}. Name`,
        name: `accessories.${index}.label`,
        type: "text",
        placeholder: "Name",
        col: { md: 4 },
        index
      },
      {
        label: "Accessory is okay?",
        name: `accessories.${index}.is_okay`,
        type: "radio",
        col: { md: 3 },
        options: [
          {
            value: "1",
            label: "Yes"
          },
          {
            value: "2",
            label: "No"
          }
        ],
        index
      },
      {
        label: "Remarks",
        name: `accessories.${index}.remarks`,
        type: "text",
        placeholder: "Remarks",
        col: { md: 3 },
        index
      },
      {
        name: `RemoveVehicleInventoryAccessoriesAckField-${index}`,
        type: "custom",
        customComponent: RemoveVehicleInventoryAccessoriesAckField,
        col: { md: 2 },
        others: { index, setFields },
        index
      }
    ];
  }, []);

  // if have default value then call only one time generateFields
  useEffect(() => {
    function handleDefaultValue() {
      const initFields =
        (arrayMap(accessories, (item, index) => generateFields(item, index)) || []).flat() ||
        undefined;

      if (initFields) {
        setFields(initFields);
      }
    }

    handleDefaultValue();
  }, [accessories, generateFields, haveAccessories]);

  // handle add new additional cost
  const handleAdd = (index) => {
    const field = generateFields(null, index);
    setCount((prev) => prev + 1);
    setFields((prev) => [...prev, ...field]);
  };

  const isLoading = false;

  return (
    <>
      <FormSectionContainer
        setValue={setValue}
        fields={fields}
        control={control}
        watch={watch}
        errors={errors}
        loading={isLoading}
        unregister={unregister}>
        {/* render additional cost title and add button */}
        <div className="row align-items-center mb-3">
          <div className="col-6">
            <FormSectionTitle>Accessories Acknowledge</FormSectionTitle>
            <p>
              {fields.length === 0 ? (
                accessories?.length ? (
                  "Save now, then edit again to get all default accessories."
                ) : (
                  "To add accessories, click the 'Add' button."
                )
              ) : accessories?.length ? (
                <span className="text-danger fst-italic fw-light">
                  <b>Note:</b> To retrieve all default accessories, please remove all accessories
                  and save. Then, edit again.
                </span>
              ) : (
                ""
              )}
            </p>
          </div>
          <div className="col-6">
            <div className="text-end">
              <Button onClick={() => handleAdd(count)} name="Add" icon={AddIcon} />
            </div>
          </div>
        </div>
      </FormSectionContainer>
    </>
  );
}
